import { render, staticRenderFns } from "./TextareaCounted.vue?vue&type=template&id=5836f44d&scoped=true"
import script from "./TextareaCounted.vue?vue&type=script&lang=js"
export * from "./TextareaCounted.vue?vue&type=script&lang=js"
import style0 from "./TextareaCounted.vue?vue&type=style&index=0&id=5836f44d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836f44d",
  null
  
)

export default component.exports